import React from "react";

import { Grid, Skeleton } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

interface SkeletonGroupProps {
  lines: number;
  groupSx?: SxProps<Theme>;
}

export const SkeletonGroup = ({ groupSx, lines }: SkeletonGroupProps) => {
  return (
    <Grid container direction={"column"} sx={groupSx}>
      {[...Array(lines).keys()].map((i) => (
        <Grid item key={i}>
          <Skeleton variant="text" />
        </Grid>
      ))}
    </Grid>
  );
};
